<template>
  <div class="bg-mask"></div>
</template>

<script>
export default {

}
</script>

<style lang='less'>
.bg-mask {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background-color: rgba(0,0,0,.6);
    z-index: 998;
}
</style>